import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "& > *": {
      margin: theme.spacing(1),
    },
    "& .statusTblheader": {
      backgroundColor: "rgba(255, 7, 0, 0.55)",
    },
  },
  snackbarSuccess: {
    backgroundColor: theme.palette.success.main,
  },
  statusTblheader: {
    backgroundColor: "rgba(255, 7, 0, 0.55)",
  },
  snackbarError: {
    backgroundColor: theme.palette.error.main,
  },
  listSection: {
    margin: "0 auto",
  },
  paidInvoiceList: {
    margin: "0 auto",
  },
  formList: {
    marginTop: "20px",
  },
  formLink: {
    textDecoration: "none",
    color: theme.palette.primary.dark,
  },
  h2heading: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  listContent: {},
  primaryBtn: {
    display: "inline-block",
    border: "1px solid #000",
  },
  actionsButtons: {
    display: "flex",
    alignItems: "center",
  },
  container: {
    minHeight: "50rem",
    padding: "3rem 0rem",
    "& div[class^=MuiTabs-flexContainer]": {
      margin: "0 5rem 3rem 5rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "3rem 0",
      "& div[class^=MuiTabs-flexContainer]": {
        margin: 0,
      },
    },
  },
  dueListHeader: {
    minWidth: 100,
  },
  paidListHeader: {
    minWidth: 90,
  },
  dueColumHeader: {
    minWidth: 80,
  },
  alignCenter: {
    textAlign: "center",
    minWidth: 57,
  },
  invoiceName: {
    minWidth: "22rem",
    textAlign: "center",
  },
  background1: {
    backgroundColor: "#0055a5",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "23vh",
    zIndex: 0,
  },
  btn: {
    width: "6rem",
  },
}));
